import { render, staticRenderFns } from "./AmountCYInputBbxkPage.vue?vue&type=template&id=5109b94e&scoped=true"
import script from "./AmountCYInputBbxkPage.vue?vue&type=script&lang=js"
export * from "./AmountCYInputBbxkPage.vue?vue&type=script&lang=js"
import style0 from "./AmountCYInputBbxkPage.vue?vue&type=style&index=0&id=5109b94e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5109b94e",
  null
  
)

export default component.exports